import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Flex, Button, Text, Box, VStack } from "@chakra-ui/react";
import { FaPepperHot } from "react-icons/fa";

import PageOne from "./PageOne";
import CategorySection from "./CategorySection";

export default function NewMenu() {
  const componentRef = useRef();
  const componentRefTwo = useRef();
  
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrintTwo = useReactToPrint({
    content: () => componentRefTwo.current,
  });

  return (
    <Flex direction="column">
      <Flex gap={4} p={4}>
        <Button colorScheme="red" onClick={() => handlePrint()} size="lg">
          Print First Page
        </Button>
        <Button colorScheme="red" onClick={() => handlePrintTwo()} size="lg">
          Print Second Page
        </Button>
      </Flex>

      {/* First Page */}
      <Flex
        className="menuOne"
        ref={componentRef}
        direction="row"
        fontSize="menusm"
        height="100vh"
        bg="white"
      >
        <style type="text/css" media="print">
          {" @page { size: landscape; } "}
        </style>
        <PageOne />
      </Flex>

      {/* Second Page */}
      <Flex
        ref={componentRefTwo}
        direction="row"
        fontSize="menusm"
        height="100vh"
        bg="white"
      >
        <style type="text/css" media="print">
          {" @page { size: landscape; } "}
        </style>
        
        {/* Column 1: Appetizers, Soup, Beef */}
        <MenuColumn>
          <CategorySection category="Appetizers" index={1} marginFlag={true} />
          <CategorySection category="Soup" index={2} marginFlag={true} />
          <CategorySection category="Beef" index={4} marginFlag={true} />
          <FooterNote />
        </MenuColumn>

        {/* Column 2: Pork, Chicken */}
        <MenuColumn>
          <CategorySection category="Pork" index={3} marginFlag={true} />
          <CategorySection category="Chicken" index={5} marginFlag={true} />
          <FooterNote />
        </MenuColumn>

        {/* Column 3: Seafood, Vegetables */}
        <MenuColumn>
          <CategorySection category="Seafood" index={6} marginFlag={true} />
          <CategorySection category="Vegetables" index={7} marginFlag={true} />
          <FooterNote />
        </MenuColumn>

        {/* Column 4: Chop Suey, Egg Foo Yung, Rice */}
        <MenuColumn>
          <CategorySection category="Chop Suey" index={8} marginFlag={true} />
          <CategorySection category="Egg Foo Yung" index={9} marginFlag={true} />
          <CategorySection category="Rice" index={12} marginFlag={true} />
          <FooterNote />
        </MenuColumn>
      </Flex>
    </Flex>
  );
}

// Reusable column wrapper
function MenuColumn({ children }) {
  return (
    <Flex
      direction="column"
      width="25%"
      borderRight="2px solid"
      borderColor="red.600"
      bg="white"
      _last={{ borderRight: "none" }}
    >
      {children}
    </Flex>
  );
}

// Reusable footer note component
function FooterNote() {
  return (
    <Box mt="auto" borderTop="2px solid" borderColor="gray.300" p={4}>
      <VStack spacing={2} fontSize="12px" color="gray.700">
        <Text textAlign="center">
          Please inform us if you have any food allergies
        </Text>
        <Flex align="center" gap={2}>
          <FaPepperHot color="#DC2626" size={12} />
          <Text>Indicates spicy</Text>
        </Flex>
      </VStack>
    </Box>
  );
}